module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/circles-8209eff90c3623ac9fbbb26e43400ec3.svg";